<template>
  <div>
    <a-modal
      :visible="cdbCustomerNum !== null"
      :maskClosable="false"
      @cancel="handleCdbCancel"
      width="82%"
      :dialog-style="{ top: '20px' }"
      class="cdbCustomerModal"
    >
      <div slot="title">Customer Profile<span style="font-weight: 400;padding-left: 8px;">SNxxxxxx</span></div>
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off" class="cdbCustomerEdit ant-advanced-search-form">
        <div class="cdbCustomerScrollBox">
          <a-row :gutter="10">
            <!-- Last Name -->
            <a-col :xs="24" :lg="3">
              <a-form-item>
                <span slot="label"><img alt="" src="@/assets/require.png" class="cdbCustomerRequire">Last</span>
                <a-input
                  @change="handleNameChange"
                />
              </a-form-item>
            </a-col>
            <!-- First Name -->
            <a-col :xs="24" :lg="3">
              <a-form-item>
                <span slot="label"><img alt="" src="@/assets/require.png" class="cdbCustomerRequire">First</span>
                <a-input
                  @change="handleNameChange"
                />
              </a-form-item>
            </a-col>
            <!-- Middle Name -->
            <a-col :xs="24" :lg="3">
              <a-form-item>
                <span slot="label"><img alt="" src="@/assets/require.png" class="cdbCustomerRequire">Middle</span>
                <a-input
                    @change="handleNameChange"
                />
              </a-form-item>
            </a-col>
            <!-- Gender -->
            <a-col :xs="24" :lg="3">
              <a-form-item>
                <span slot="label"><img alt="" src="@/assets/require.png" class="cdbCustomerRequire">Gender</span>
                <a-select>
                  <a-select-option value="M">M</a-select-option>
                  <a-select-option value="F">F</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- Title -->
            <a-col :xs="24" :lg="3">
              <a-form-item label="Title">
                <a-select>
                  <a-select-option v-for="t in titleList" :key="'title-' + t.code" :value="t.code">{{ t.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 生日 -->
            <a-col :xs="24" :lg="4">
              <a-form-item>
                <span slot="label"><img alt="" src="@/assets/require.png" class="cdbCustomerRequire">DOB</span>
                <a-input
                  placeholder="mm/dd/yyyy"
                  :maxLength="10"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :lg="4" class="rematchBox">
              <a-form-item label=" ">
                <a-button type="primary" ghost @click="handleRematch">
                Rematch
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="10">
            <!-- Language -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="Primary Language">
                <a-select
                  :showArrow="true"
                >
                  <a-select-option v-for="i in languageList" :key="'languages-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- background -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="Origin">
                <a-select
                  :showArrow="true"
                >
                  <a-select-option :value="''">N/A</a-select-option>
                  <a-select-option v-for="i in backgroundList" :key="'background-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 邮箱 -->
            <a-col :xs="24" :lg="5">
              <a-form-item label="Email" class="cdbCustomerInput">
                <a-input/>
              </a-form-item>
            </a-col>
            <!-- 电话-->
            <a-col :xs="24" :lg="7" style="padding-right: 0;">
              <a-form-item label="Contact number">
                <PhonenumberInput :initData="{ countryCode: 'US', countryCallingCode: '1', isValid: false, phoneNumber: '' }"/>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :lg="2" class="phone-number-extension">
              <a-form-item label=" ">
                <a-input
                  placeholder="Ext."
                  class="phone-number-extension-input"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!-- *************************** 地址输入开始 ***************************** -->
          <div>
            <div class="mailingInfo">Mailing info: </div>
            <a-row :gutter="10" class="addressBox">
              <a-col :xs="24" :lg="4">
                <!-- 国家 -->
                <a-form-item label="Country">
                  <a-select
                    :showSearch="true"
                    optionFilterProp="children"
                  >
                    <a-select-option v-for="i in countryList" :key="'country-' + i.id" :value="i.id">{{ i.nameEnUs }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="8">
                <!-- 地址 -->
                <a-form-item label="Address">
                  <a-textarea
                    auto-size
                  />
                </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="4">
                <!-- 城市 -->
                <a-form-item label="City">
                  <a-input/>
                </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="4">
                <!-- 州 -->
                <a-form-item label="State/Province">
                  <a-select
                    :showSearch="true"
                    optionFilterProp="children"
                  >
                    <a-select-option v-for="s in stateList" :key="'state-' + s.id" :value="s.id">{{ s.nameEnUs }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="4">
                <!-- 邮编 -->
                <a-form-item label="Zip">
                  <a-input/>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <!-- *************************** 护照输入开始 ***************************** -->
          <div style="padding: 4px 0;">
            <a-row :gutter="10">
              <a-col :xs="24" :lg="1" style="width: 26px;">
              </a-col>
              <a-col :xs="24" :lg="8">
                <span class="form-row-title">Travel Doc.</span>
              </a-col>
              <a-col :xs="24" :lg="3">
                <span class="form-row-title">Exp. Date</span>
              </a-col>
              <a-col :xs="24" :lg="4">
                <span class="form-row-title">Surname</span>
              </a-col>
              <a-col :xs="24" :lg="4">
                <span class="form-row-title">Given Names</span>
              </a-col>
              <a-col :xs="24" :lg="3" v-show="false">
                <span class="form-row-title">Middle</span>
              </a-col>
              <a-col :xs="24" :lg="4">
                <span class="form-row-title">DOB</span>
              </a-col>
              <a-col :xs="24" :lg="1">
              </a-col>
            </a-row>
            <a-row :gutter="10">
              <a-col :xs="24" :lg="1" style="line-height: 32px;height: 32px;width: 26px;padding-right: 0;">
                <a-radio></a-radio>
              </a-col>
              <!-- 护照类型 -->
              <a-col :xs="24" :lg="8" style="display:flex;padding-right: 0;">
                <a-form-item>
                    <a-select
                      :dropdownMatchSelectWidth="false"
                      style="width: 140px;"
                      :showSearch="true"
                      optionFilterProp="children"
                    >
                      <a-select-option v-for="i in passportList" :key="'passportType-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- 护照号码 -->
                  <a-form-item style="width: 100%;">
                    <a-input
                      placeholder="Numbers"
                      style="margin-left: -5px;border-bottom-left-radius: 0;border-top-left-radius: 0;"
                      :maxLength="30"
                    />
                </a-form-item>
              </a-col>
              <!-- 护照有效期 -->
              <a-col :xs="24" :lg="3">
                  <a-form-item>
                    <a-input
                      placeholder="mm/dd/yyyy"
                      :maxLength="10"
                      />
                  </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="4">
                <!-- Last Name -->
                <a-form-item>
                    <a-input
                      @change="handleNameChange"
                    />
                  </a-form-item>
              </a-col>
              <!-- First Name -->
              <a-col :xs="24" :lg="4">
                <a-form-item>
                    <a-input
                      @change="handleNameChange"
                    />
                  </a-form-item>
              </a-col>
              <!-- Middle Name -->
              <a-col :xs="24" :lg="3" v-show="false">
                <a-form-item>
                    <a-input
                      @change="handleNameChange"
                    />
                  </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="3">
                <a-form-item>
                  <a-input
                    placeholder="mm/dd/yyyy"
                    :maxLength="10"
                  />
                  </a-form-item>
              </a-col>
              <a-col :xs="24" :lg="1" style="padding-left: 0;padding-right: 0;text-align: center;">
                <a @click="handlePassportAdd" class="cdb-customer-add">
                <a-icon type="plus"/>
              </a>
              <a-popconfirm
                title="Are you sure?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="handlePassportDelete"
              >
                <a class="cdb-customer-add"><a-icon type="delete" /></a>
              </a-popconfirm>
              </a-col>
              <!-- 隐藏 -->
              <!-- <a-form-item v-show="false">
                <a-input v-decorator="['passport-' + pindex + '-internalCode',{initialValue: p.internalCode ? p.internalCode : '', rules: [{ required: false}]}]"/>
            </a-form-item> -->
            </a-row>
          </div>
          <!-- *************************** 护照输入结束 ***************************** -->
          <a-row :gutter="10" style="border-top: 1px #d9d9d9 solid;padding-top:8px;">
            <!-- RM pref. -->
            <a-col :xs="24" :lg="3">
              <a-form-item
                label="RM Type"
              >
                <a-select
                  :showArrow="true"
                >
                  <!-- <a-select-option :value="''">N/A</a-select-option> -->
                <a-select-option value="1">TWN</a-select-option>
                <a-select-option value="2">DBL</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 特别餐食 -->
            <a-col :xs="24" :lg="11">
              <a-form-item
                label="Meals restriction"
              >
                <a-select
                  mode="multiple"
                  :showArrow="true"
                >
                  <a-select-option v-for="i in mealsList" :key="'mealsRequest-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 特别要求 -->
            <a-col :xs="24" :lg="10">
              <a-form-item
                label="Special request"
              >
                <a-select
                  mode="multiple"
                  :showArrow="true"
                >
                  <a-select-option v-for="i in specialList" :key="'mealsRequest-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 特别备注 -->
          <a-row :gutter="10">
            <a-col :span="24">
              <a-form-item
                label="Internal Note"
              >
                <a-textarea
                  auto-size
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-row class="cdbCustomerRow">
          <a-col :xs="24" :lg="7">
            <div>
              <a-form-item>
                <span class="cdbCustomerMember">Member already ?</span>
                <span>Yes<span style="margin-left: 20px;">Coupon: 15913</span></span>
              </a-form-item>
            </div>
            <div>
              <a-form-item>
                <span class="cdbCustomerMember">Become a member ?</span>
                <a-radio-group>
                  <a-radio value="1">Yes</a-radio>
                  <a-radio value="0">No</a-radio>
                </a-radio-group>	
              </a-form-item>
            </div>
          </a-col>
        </a-row>
        <!-- 隐藏域 -->
        <a-form-item v-show="false">
          <a-input v-decorator="['id',{rules: [{ required: false}]}]"/>
        </a-form-item>
        <a-form-item v-show="false">
          <a-input v-decorator="['companyCode',{rules: [{ required: false}]}]"/>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleCdbConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
    <div>
      <select-customer
        :cdbSelectCustomerNum="SelectCustomerProfile" 
        @cancel="() => { this.SelectCustomerProfile = null }"
        @confirm="() => { this.SelectCustomerProfile = null }"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
// import CountryApi from '@/api/basicdata/api-country'
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'
import SelectCustomer from './BookMatchSelectCustomerProfile'
import { Title } from '@/utils/helper/standard-code-utils'
import { Background } from '@/utils/helper/dict-cdb-utils'
// import { PassportTravelDocType } from '@/utils/helper/standard-code-utils'
// import { Language } from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'BookMatchCustomerProfile',
  components: {
    PhonenumberInput,
    SelectCustomer
  },
  props: {
    cdbCustomerNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      phoneNumberData: null,
      titleList: Title.dict,
      backgroundList: [],
      languageList: [],
      editForm: this.$form.createForm(this),
      countryList: [],
      stateList: [],
      // PassportTravelDocList:PassportTravelDocType.dict,
      passportList: [],
      mealsList: [],
      specialList: [],
      SelectCustomerProfile: null
    }
  },
  mounted () {
  },
  methods: {
    async loadData() {
      this.backgroundList = await Background.getDict()
    },
    handleCdbCancel () {
      this.$emit('cancel')
    },
    handleCdbConfirm () {
       this.$emit('confirm')
    },
    handlePassportAdd () {

    },
    handlePassportDelete () {

    },
    handleRematch () {
      this.SelectCustomerProfile = 'true'
    },
    // 处理了名字变化
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    }
  }
}
</script>
<style lang="less" scoped>
.cdbCustomerRequire {
  height: 12px;
  margin-right: 2px;
  position: relative;
  bottom: 1px;
}
.cdbCustomerScrollBox ::v-deep .ant-form-item {
  margin-bottom: 10px;
}
.cdbCustomerScrollBox ::v-deep .ant-form-item-label > label {
  font-weight: bold;
}
.cdbCustomerScrollBox ::v-deep .ant-form-item-label {
  line-height: 30px;
}
.cdbCustomerModal ::v-deep .ant-form-item-control {
  line-height: normal;
}
.cdbCustomerRow ::v-deep .ant-form-item {
  margin-bottom: 0px;
}
.cdbCustomerRow .cdbCustomerMember {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  padding-right: 10px;
}
.rematchBox ::v-deep .ant-form-item-label > label::after{
  content: '';
}
.phone-number-extension {
  padding-left: 0 !important;
  margin-left: -3px;
}
.phone-number-extension-input {
  height: 40px;
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}
.phone-number-extension ::v-deep .ant-form-item-label > label::after {
  content: '';
}
.cdbCustomerModal ::v-deep .ant-modal-body{
  padding: 10px 24px 24px 24px;
}
.addressBox {
	border-bottom: 1px #d9d9d9 solid;
}
.addressBox ::v-deep .ant-form-item-label>label:after {
	content: "";
}
.mailingInfo {
	color: #000;
	font-size: 16px;
	font-weight: bold;
}
.form-row-title {
  font-weight: bold;
  color: #000;
  line-height: 30px;
}
.cdb-customer-add {
	height: 34px;
	line-height: 34px;
	display: inline-block;
  padding-right: 4px;
}
.cdbCustomerEdit {
	padding-right: 24px;
	height: 410px;
  overflow-y: auto;
  overflow-x: hidden;
}
.cdbCustomerEdit::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 6px;  /*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}
.cdbCustomerEdit::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: #ccc;
}
.cdbCustomerEdit::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background: #ededed;
}
</style>